<template>
  <div>
    <bs-card class="card-info" :icon="['fal', 'location']" :label="$t('labels.' + camelToSnake($options.name))">
      <bs-table v-bind="{dataLength, loading}" :cols="6">
        <template v-slot:thead>
          <tr>
            <bs-th class="clickable" :label="$t('labels.time')" :sortable="resourceState.sort" :col="'created_at'" @click="applySort"></bs-th>
            <bs-th>{{ $t('labels.latitude') }}</bs-th>
            <bs-th>{{ $t('labels.longitude') }}</bs-th>
            <bs-th>{{ $t('labels.altitude') }}</bs-th>
            <bs-th>{{ $t('labels.direction') }}</bs-th>
            <bs-th>{{ $t('labels.speed') }}</bs-th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>{{ timeFormat(r.created_at) }}</td>
          <td>{{ r.lat }}</td>
          <td>{{ r.lng }}</td>
          <td>{{ r.altitude }} m</td>
          <td>{{ r.angle }} &deg;</td>
          <td>{{ r.speed }} km/h</td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'Tracking',
  props: ['vehicle'],
  data () {
    return {
      loading: false,
      dataLoading: false
    }
  },
  mounted () {
    this.index()
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resourceState: state => state.trackingState,
      resources: state => state.tracking,
      submitting: state => state.submitting
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    }
  },
  methods: {
    timeFormat (dt) {
      return DateTime.fromISO(dt).toFormat('FFF')
    },
    applySort (val) {
      this.pushState({ view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    ...mapMutations([
      'pushState'
    ]),
    index (page, count) {
      if (page) this.pushState({ view: this.$options.name, key: 'page', data: page })
      if (count) this.pushState({ view: this.$options.name, key: 'tableRows', data: count })
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name, path: 'vehicles', id: this.vehicle, tag: 'tracking' }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
